import { Space, Button, Breadcrumb, Form, Input, Alert } from 'antd'
import { useRequest, useUpdateEffect } from 'ahooks'
import React, { memo, useState } from 'react'
import classnames from 'classnames'
import { Link, useNavigate, useParams } from 'react-router-dom'
import useProjectContext from '@/hooks/useProject'
import { loadDimensions } from '@/services/dimension/dimension.service'
import styles from './index.module.less'
import { UnitRow, UnitVal } from './CreateEditUnit/UnitRow'
import { UnitSet } from '@/services/unitSet/unitSet.model'
import { Dimension } from '@/services/dimension/dimension.model'
import { createUnitSet, getUnitSet, updateUnitSet } from '@/services/unitSet/unitSet.service'
import {isNil} from 'lodash-es'

interface FormValModal {
  name: string
  dims: {[key: string]: UnitVal}
}

function unitSetToFormVal(unitSet: UnitSet | undefined, dimensions: Dimension.Info[]): FormValModal {

  const units = unitSet?.units || [];

  const dims = dimensions.reduce((res, cur) => {
    const curUnitEntity = units.find((item) => item.dim === cur.id)
    res[cur.code] = {
      dim: cur.id,
      unit: curUnitEntity?.unit?.id,
      format: curUnitEntity?.format,
      digits: curUnitEntity?.digits,
      cutoff: curUnitEntity?.cutoff,
    }
    return res;
  }, {})

  console.log(dims)
  
  return {
    name: unitSet?.name || '',
    dims,
  }
}

const UnitSetItem = memo(() => {
  const { projectType, projectId } = useProjectContext()
  const { id } = useParams()
  const navigate = useNavigate()
  const { data: dimensions = [] } = useRequest(loadDimensions)
  const isCreate = !id
  const [valid, setValid] = useState<null | boolean>(null);

  const { data: unitSet, refresh: refreshUnitSet } = useRequest(() => getUnitSet({ projectType, projectId, id }), {
    ready: !!id
  })

  const [form] = Form.useForm()

  useUpdateEffect(() => {
    const newFormVal = unitSetToFormVal(unitSet, dimensions)
    form.setFieldsValue(newFormVal)
  }, [dimensions, unitSet])

  const onSave = async (values) => {
    const units = Object.values(values.dims)
    const newUnitSetData = {
      name: values.name,
      units: units
    }
    if (!isCreate) {
      await updateUnitSet({ projectId, id: unitSet!.id }, newUnitSetData)
    } else {
      await createUnitSet({ projectId }, newUnitSetData)
    }
    navigate('../')
  }

  const onCancel = () => {
    navigate('../')
  }

  return (
    <div style={{width: 810}}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={'../'}>Unit Set</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item> {isCreate ? 'Create unit set' : 'Detail'} </Breadcrumb.Item>
      </Breadcrumb>

      <div className={classnames('mt-2')}>
        <Form form={form} onFinish={onSave} onFinishFailed={() => setValid(false)}>
          <div className='mt-2 flex-end mb-2'>
            <Space >
              <Button onClick={onCancel}>Cancel</Button>
              <Button type='primary' htmlType='submit'>Save</Button>
            </Space>
          </div>
          <Alert className='mb-2' message="Please fill all the below fields" type={valid === false ? 'error' : 'info'} showIcon />
          
          <Form.Item label='Name' name='name' required>
            <Input placeholder='Please input the unit set name' style={{width: 300}}/>
          </Form.Item>
          <Form.Item name='dims' noStyle>
            {dimensions.map((dim) => {
              return <Form.Item
                name={['dims', dim.code]}
                layout='horizontal'
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (isNil(value.unit) || isNil(value.format) || isNil(value.cutoff)) {
                        return Promise.reject()
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}  
                required >
                  <UnitRow dim={dim}/>
                </Form.Item>
            })}
          </Form.Item>
        </Form>
      </div>
     
    </div>
  )
})

export default UnitSetItem
